<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title_flex">
        <div class="componentSty_content_title">
          <span class="fonints">车牌号码</span>
          <el-input placeholder="请输入关键词" v-model="conditions.plate" clearable>
          </el-input>
          <span class="fonints">充电状态</span>
          <div class="select_box1">
            <el-select v-model="conditions.chargestate" class="m-2" clearable>
              <el-option v-for="item in dischargeoptions" :key="item" :label="item" :value="item" />
            </el-select>
          </div>
          <span class="fonints">车辆状态</span>
          <div class="select_box1">
            <el-select v-model="conditions.vehstate" class="m-2" clearable>
              <el-option v-for="item in vehstatelist" :key="item" :label="item" :value="item" />
            </el-select>
          </div>

        </div>
        <div class="componentSty_content_title_flex_button">
          <button class="buttons" @click="selectlist">查询</button>
          <button class="buttons" style="color: #17B6A1;background-color: #F3F4F5;" @click="clearlist">重置</button>
        </div>
      </div>
      <div class="componentSty_content_title">
        <span class="fonints">所属车队</span>
        <el-input style="width: 160px" placeholder="请输入关键词" v-model="conditions.shortname" clearable>
        </el-input>
        <!-- <span class="fonints">排放标准</span>
          <div class="select_box1">
            <el-select v-model="discharge" class="m-2" clearable>
              <el-option v-for="item in dischargelist" :key="item" :label="item" :value="item" />
            </el-select>
          </div> -->
          <span class="fonints">作业状态</span>
          <div class="select_box1">
            <el-select v-model="workecar" class="m-2" clearable>
              <el-option v-for="item in workelist" :key="item" :label="item" :value="item" />
            </el-select>
          </div>
          <span class="fonints">剩余电量</span>
          <div class="select_box1">
            <el-select v-model="soc" class="m-2" clearable>
              <el-option v-for="item in socList" :key="item.value" :label="item.name" :value="item.value" />
            </el-select>
          </div>
      </div>
      <div class="componentSty_content_table" style="top: 90px;border:none">
        <el-table :data="arrlist.list" style="width: 100%; height: 80%" border height="80%">
          <el-table-column show-overflow-tooltip label="序号" type="index" width="50px"></el-table-column>
          <el-table-column show-overflow-tooltip prop="plate" label="车牌号码">
          </el-table-column>
          <!-- <el-table-column
              show-overflow-tooltip
              prop="hangPlate"
              label="挂车号码"
            >
            </el-table-column> -->
          <el-table-column show-overflow-tooltip prop="shortname" label="车队名称">
          </el-table-column>
          <!-- <el-table-column show-overflow-tooltip prop="wenjianjia" label="分组名称">
          </el-table-column> -->
          <el-table-column show-overflow-tooltip prop="discharge" label="排放标准">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="soc" label="剩余电量(%)" :render-header="renderHeader">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="mileage" label="总行驶里程(公里)" :render-header="renderHeader">
          </el-table-column>
          <el-table-column show-overflow-tooltip label="限定载重">
            <template v-slot="res">
              <span>{{
                res.row.truckTypecode && res.row.truckTypecode + '吨'
              }}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="workStatus" label="作业状态">
            <!-- <template v-slot="res">
              <span>{{
                res.row.workStatus 
              }}</span>
            </template> -->
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="vehstate" label="车辆状态">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="chargestate" label="充电状态">
          </el-table-column>
          <el-table-column show-overflow-tooltip label="操作">
            <template v-slot="res">
              <span @click="jumpParticulars(res.row)" style="color: #13D168; cursor: pointer;">查看位置</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="msgstatistics">
          <span style="margin-right: 20px">车辆合计:{{ arrlist.total }}辆</span>
        </div>
        <div class="paginations" v-show="arrlist.list && arrlist.list.length">
          <el-pagination :page-size="conditions.limit" layout="total,prev, pager,next, jumper" :total="arrlist.total"
            :current-page="conditions.page" @current-change="getMemberlist">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from '@/components/mTitle';
import { mapMutations, mapState } from 'vuex';
import mSelect from '@/components/mSelect.vue';
import { antiShake } from '@/plugins/other.js';
export default {
  name: 'addcarlistinfo',
  data() {
    return {
      connState: 1,
      isReading: false, //读卡状态 。
      listitem: [{ name: '会员管理' }, { name: '会员列表' }],
      arrlist: [],
      conditions: {
        page: 1,
        limit: 20,
        chargestate: '',
        plate: "",
        shortname: "",
        vehstate: "",
      },
      stateName: '全部',
      vehstatelist: ['其他', '启动', '熄火'], //作业节点
      dischargeoptions: ["未充电", "停车充电"],
      dischargelist:['全部','新能源 (氢)','新能源 (电)'],
      discharge:"新能源 (电)",
      workelist:['全部','工作中','空闲中'],
      workecar:'全部',
      socList:[
        {name:'全部',value:null},
        {name:'0-20',value:20},
        {name:'20-40',value:40},
        {name:'40-60',value:60},
        {name:'60-80',value:80},
        {name:'80-100',value:100},
      ],
      soc:null
    };
  },
  components: {
    mSelect,
    mTitle,
  },
  computed: {
    ...mapState(['conditionsList']),
  },
  created() {
    console.log(this.$route.query.obj);
    if(this.$route.query.obj){
      this.soc=JSON.parse(this.$route.query.obj).num
      this.conditions.shortname=JSON.parse(this.$route.query.obj).shortname
      this.conditions.vehstate=JSON.parse(this.$route.query.obj).vehstate
      this.workecar=JSON.parse(this.$route.query.obj).workecar
    }
    this.getMemberlist();
  },

  methods: {
    ...mapMutations(['createConditions']),
    async getMemberlist(num) {
      typeof num === 'number' && (this.conditions.page = num);
        this.conditions.discharge=this.discharge
        this.conditions.soc=this.soc
      if(this.workecar=='全部'){
        this.conditions.workStatus=''
      }else{
        this.conditions.workStatus=this.workecar
      }
      const { data } = await this.$http(
        'api1',
        '/api/replenish/station/energyCarList',
        'post',
        this.conditions
      );
      console.log(data);
      if (!data || data.code != '0')
        return this.$message.error('获取数据失败');
      this.arrlist = data.data;
    },

    jumpParticulars(row) {
      // localStorage.setItem('carposition','1')
      sessionStorage.setItem('positioncar', JSON.stringify(row))
      this.$router.push({ path: "/home/homemapdetail" })

    },
    //查询
    selectlist() {
      antiShake((_) => {
        this.conditions.page = 1;
        
        this.getMemberlist();
      });
    },
    //重置
    clearlist() {
      this.conditions.chargestate = ""
      this.conditions.plate = ""
      this.conditions.shortname = ""
      this.conditions.vehstate = ""
      this.discharge='新能源 (电)'
      this.workecar="全部"
      this.getMemberlist();
    },
  },
  beforeDestroy() {
    window.ws && window.ws.close();
    window.ws = null;
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>
  